<template>

    <BaseContainer class="dnnCloud-order-box" :loading="listLoading" :isHasPageFt="!listLoading">
        <template v-slot:hd>
            <!--工具条-->
            <el-col :span="24" class="toolbar">
              <el-form :inline="true" :model="souchs" @submit.native.prevent>
                <!-- <el-select v-model="value" placeholder="请选择" @change="changeSouch" >
                  <el-option v-for="item in options" :key="item.value"  
                    :label="item.label" :value="item.value">
                  </el-option>
                </el-select> -->
                <el-form-item>
                  <el-input  v-model="searchText"  placeholder="用户 / 企业 / 价格" style="width:180px;" clearable @keyup.enter.native="getList(1)"></el-input>
                </el-form-item>

                <el-form-item>
                  <el-select v-model="souchs.souType" placeholder="类型" style="width:160px;" clearable >
                    <el-option v-for="item in types" :key="item.value" 
                      :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item>
                  <el-select v-model="souchs.souAccount" placeholder="订单" style="width:160px;" clearable >
                    <el-option v-for="item in accountTypes" :key="item.value" 
                      :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>

                 <el-form-item>
                   <el-date-picker  style="width:180px;"  v-model="souchs.fromtime" format="yyyy-MM-dd" 
                      value-format="yyyy-MM-dd" type="date" placeholder="开始日期时间"> 
                  </el-date-picker>
                 </el-form-item>

                 <el-form-item>
                   <el-date-picker  style="width:180px;"  v-model="souchs.totime" format="yyyy-MM-dd" 
                    value-format="yyyy-MM-dd" type="date" placeholder="结束日期时间"> 
                  </el-date-picker>
                 </el-form-item>

                <!-- <el-form-item>
                  <el-input v-show="disSouch" v-model="proName" style="width:200px;"  @keyup.enter.native="getList(1)"></el-input>
                  <el-select v-show="disType" v-model="typeValue" placeholder="请选择" style="width:200px;" clearable >
                    <el-option v-for="item in types" :key="item.value" 
                      :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                  <el-select v-show="disAccountType" v-model="accountType" placeholder="请选择" style="width:200px;" clearable >
                    <el-option v-for="item in accountTypes" :key="item.value" 
                      :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                  <el-date-picker v-show="disTime1" style="width:200px;"  v-model="souchs.fromtime" format="yyyy-MM-dd" 
                      value-format="yyyy-MM-dd" type="date" placeholder="开始日期时间"> 
                  </el-date-picker>
                  <el-date-picker v-show="disTime2" style="width:200px;"  v-model="souchs.totime" format="yyyy-MM-dd" 
                    value-format="yyyy-MM-dd" type="date" placeholder="结束日期时间"> 
                  </el-date-picker>
                </el-form-item> -->
                <el-form-item>
                  <el-button type="primary" size="medium" v-on:click="getList(1)">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary"  size="medium" v-on:click="addList">新增</el-button>
                </el-form-item>
              </el-form>
              <el-tag :key="tag" v-for="tag in dynamicTags" closable 
                :disable-transitions="false" @close="handleClose(tag)"> 
                  {{tag}} 
              </el-tag>
              <el-button v-if="dynamicTags!=''" class="button-new-tag" size="small" @click="delTags">清除标签</el-button>
            </el-col>
        </template>

        <template v-slot:main>
           <!--列表-->
          <el-table :data="dataList" highlight-current-row  @selection-change="selsChange" :height="maxTbHeight"
            style="width: 100%;" :header-cell-style="getRowClass"  @sort-change="handleSortChange">
            <el-table-column type="index" :index="indexMethod" label="序号" width="80">
              <template slot-scope="scope">
                  <span>{{(pageNumber - 1) * pageSize + scope.$index + 1}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="id" label="ID" min-width="200" sortable="custom" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="name" label="用户" min-width="120" sortable="custom" show-overflow-tooltip>
              <template slot-scope="scope">
                  <span>{{ scope.row.userid? scope.row.name: '-'}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="usercompany" label="企业" min-width="260" sortable="custom" show-overflow-tooltip>
              <template slot-scope="scope">
                  <span>{{ scope.row.userid? scope.row.usercompany : scope.row.name }}</span>
              </template>
            </el-table-column>        
            
            <el-table-column prop="intime" label="时间" min-width="180" sortable="custom" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="adminusername" label="操作人" min-width="120" sortable="custom" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="price2" label="价格(元)" min-width="120" sortable="custom" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="typename" label="类型" min-width="120" sortable="custom" show-overflow-tooltip>
               <template slot-scope="scope">
                  <span class="myTag" :class="scope.row.type == 1? 'primary': 'success'" >{{ scope.row.typename  }}</span>
              </template>
            </el-table-column>
            <el-table-column type="stateverify" label="订单状态" width="120">
              <template slot-scope="scope">
                  <span class="myTag" :class="scope.row.stateverify == 1? 'warning': 'primary'" >{{ scope.row.stateverify == 1? "申请中": '审核通过' }}</span>
              </template>
            </el-table-column>

            <el-table-column type="isrenew" label="续订订单" width="100">
              <template slot-scope="scope">
                  <span class="myTag-fill" :class="scope.row.isrenew == 2? 'pruple': 'primary'" >{{ scope.row.isrenew == 2? "是": '否' }}</span>
              </template>
            </el-table-column>

            <el-table-column label="操作" fixed="right" min-width="140" style="text-algin:center">
              <template slot-scope="scope">
                <span class="operate">
                    <el-tooltip effect="dark" content="详情" placement="top">
                      <span class="dnnfont iconfile-search"  @click="handleDetail(scope.$index, scope.row, 1)"></span>
                    </el-tooltip>
                    
                    <!-- 	stateverify 1：申请状态 2：审核完成状态 -->
                    <template v-if="scope.row.adminuserid == userInfo.id && scope.row.stateverify ==1">
                        <el-tooltip effect="dark" content="编辑" placement="top"  v-if="scope.row.isrenew !=2">
                          <span class="dnnfont iconEdit"  @click="handleEdit(scope.$index, scope.row)"></span>
                        </el-tooltip>
                        <el-tooltip effect="dark" content="撤销" placement="top">
                          <span class="dnnfont iconundo"  @click="handleDel(scope.$index, scope.row)"></span>
                        </el-tooltip>
                    </template>
                    
                    <!-- 1、管理员 2、订单申请状态 -->
                    <el-tooltip effect="dark" content="审核" placement="top" v-if="userInfo.type == 1 && scope.row.stateverify ==1">
                       <span class="dnnfont iconapprove"  @click="handleDetail(scope.$index, scope.row, 2)"></span>
                    </el-tooltip>
                 
                </span>
              </template>
            </el-table-column>
          </el-table>
        </template>

        <template v-slot:ft>
            <!--工具条-->
            <el-col :span="24" class="toolbar" >
              <el-pagination  
                layout="sizes, prev, pager, next"
                :page-sizes="[10, 20, 30, 50,100]"
                :current-page="pageNumber" 
                :page-size="pageSize" 
                :total="total" 
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
                style="float:right;">
              </el-pagination>
            </el-col>
        </template>

      </BaseContainer>
</template>
<script>
import { mapGetters } from 'vuex'
import { API__code, API_Order} from '../../../api/index.js'
import BaseContainer from '@/components/BaseContainer'
import fitTableHeight from '@/mixins/fitTableHeight.js'
export default {
  mixins: [fitTableHeight],
  data() {
    return {
      disSouch:true,
      disType:false,
      disAccountType:false,
      disTime1:false,
      disTime2:false,
      token:'',
      checkCode:"",
      id:"",
      listLoading:false,
      dataList:[],
      souchs:{
        id:'',
        name:'',
        usercompany:'',
        souType:this.$route.query.souType?this.$route.query.souType:'',
        adminusername:'',
        souAccount:this.$route.query.souAccount?this.$route.query.souAccount:'',
        price:'',
        fromtime:this.$route.query.fromtime?this.$route.query.fromtime:'',
        totime:this.$route.query.totime?this.$route.query.totime:'',
      },
      
      proName:'',
      pageNumber:this.$route.query.pageNumber?this.$route.query.pageNumber:1,
      pageSize: this.$route.query.pageSize?this.$route.query.pageSize:20,
      total:0,
      options: [
        {value: 'ID',label: 'ID'}, 
        {value: '用户',label: '用户'},
        {value: '企业',label: '企业'},
        {value: '类型',label: '类型'},
        {value: '订单',label: '订单'},
        {value: '操作人',label: '操作人'},
        {value: '价格',label: '价格'},
        {value: '开始日期',label: '开始日期'},
        {value: '结束日期',label: '结束日期'},
      ],
      value: '',
      types:[
        {value: '1',label: '试用'},
        {value: '2',label: '正式'},
        // {value: '3',label: '续费'}
      ],
      accountType:'',
      accountTypes:[
        {value: '0',label: '个人订单'},
        {value: '1',label: '企业订单'},
      ],
      typeValue:'',
      dynamicTags: [],
      // 默认按照时间降序排序
      orderStr: "intimepx",
      orderType:'desc',
      searchText: this.$route.query.searchText,
    }
  },

  computed: {
    ...mapGetters(['userInfo', ]),
  },

  components: {
    BaseContainer
  },

  methods:{
    handleSortChange:function(val){
      if(val){
        if(val.prop == "id"){
          this.orderStr = "idpx";
        }else if(val.prop == "name"){
          this.orderStr = "namepx";
        }else if(val.prop == "phone"){
          this.orderStr = "phonepx";
        }else if(val.prop == "typename"){
          this.orderStr = "typepx";
        }else if(val.prop == "intime"){
          this.orderStr = "intimepx";
        }else if(val.prop == "adminusername"){
          this.orderStr = "adminuserpx";
        }else if(val.prop == "price2"){
          this.orderStr = "pricepx";
        }else if(val.prop == "usercompany"){
          this.orderStr = "usercompanypx";
        }
        
        if(val.order == "descending"){
          this.orderType = "desc";
        }else{
          this.orderType = "asc";
        }
      }
      this.getList();
    },

    changeSouch:function(val){
        this.disAccountType = false;
        this.disSouch = false;
        this.disType = false;
        this.disTime1 = false;
        this.disTime2 = false;
      if(val == "类型"){
        this.typeValue = this.souchs.souType;
        this.disType = true;
      }else if(val == "ID"){
        this.proName = this.souchs.id;
        this.disSouch = true;
      }else if(val == "用户"){
        this.proName = this.souchs.name;
        this.disSouch = true;
      }else if(val == "企业"){
        this.proName = this.souchs.usercompany;
        this.disSouch = true;
      }else if(val == "操作人"){
        this.proName = this.souchs.adminusername;
        this.disSouch = true;
      }else if(val == "价格"){
        this.proName = this.souchs.price;
        this.disSouch = true;
      }else if(val == "开始日期"){
        this.disTime1 = true;
      }else if(val == "结束日期"){
        this.disTime2 = true;
      }else if(val == "订单"){
        this.accountType = this.souchs.souAccount;
        this.disAccountType = true;
      }
    },

    getList:function(val){
      if(val == 1){
        this.pageNumber = 1;
      }
      if(this.value == "ID"){
        this.souchs.id = this.proName;
      }
      if(this.value == "用户"){
        this.souchs.name = this.proName;
      }
      if(this.value == "企业"){
        this.souchs.usercompany = this.proName;
      }
      if(this.value == "类型"){
        this.souchs.souType = this.typeValue;
      }
      if(this.value == "订单"){
        this.souchs.souAccount = this.accountType;
      }
      if(this.value == "操作人"){
        this.souchs.adminusername = this.proName;
      }
      if(this.value == "价格"){
        this.souchs.price = this.proName;
      }
      
      var flag = true;
      if(val == 1){
        if(this.value){
          if(this.dynamicTags.length > 0){
            for(var i=0;i<this.dynamicTags.length;i++){
              if(this.value == this.dynamicTags[i]){
                flag = false;
              }
            }
          }
          if(flag){
            this.dynamicTags.push(this.value);
          }
        }
      }
      
      let param ={
        token:this.token,
        checkCode:this.checkCode,
        pageNumber:this.pageNumber,
        pageSize:this.pageSize,
        listType:'page',
        id:this.souchs.id,
        name:this.souchs.name,
        usercompany:this.souchs.usercompany,
        type:this.souchs.souType,
        accountType:this.souchs.souAccount,
        adminusername:this.souchs.adminusername,
        price:this.souchs.price,
        fromtime:this.souchs.fromtime,
        totime:this.souchs.totime,
        orderType: this.orderType,
        orderStr: this.orderStr,
        role: this.userInfo.type,
        userId: this.userInfo.id,
        searchText: this.searchText,
      }
      this.listLoading = true;
      API_Order.getOrderList(param)
      .then((res)=>{
        if(res.data.code == API__code.SUCCESS){
          for(var i=0;i<res.data.data.list.length;i++){
            if(res.data.data.list[i].price){
              // res.data.data.list[i].price = (res.data.data.list[i].price.toString()).getAns();
              res.data.data.list[i].price = parseFloat(res.data.data.list[i].price);
              res.data.data.list[i].price2 = (res.data.data.list[i].price).toLocaleString();
            }else{
              res.data.data.list[i].price2 = 0;
            }
          }
          this.dataList = res.data.data.list;
          this.total = res.data.data.totalRow;
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'loginAdmin'});
          }
        }
        this.listLoading = false;
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
        this.listLoading = false;
      });
    },

    addList:function(){
			this.$router.push({ path: '/OrderAdd'});
    },

    handleEdit:function(index,row){
      // this.$router.push({ 
      //   path: '/OrderEdit',
      //   query:{
      //     id:row.id,
      //     name:row.name,
      //     dynamicTags: JSON.stringify(this.dynamicTags),
      //     souchs:JSON.stringify(this.souchs),
      //     pageNumber:this.pageNumber
      //   }
      // });

      this.$router.push({ path: 'OrderAdd', query: {  orderId: row.id, mode: 'update'}});
         
    },
    
    // 查看详情页面
    handleDetail(index,row, flag) {
      this.$router.push({ 
        path: 'orderDetail',
        query: {
          orderId: row.id,
          type: flag,
          searchText:this.searchText,
          souType:this.souchs.souType,
          souAccount:this.souchs.souAccount,
          fromtime:this.souchs.fromtime,
          totime:this.souchs.totime,
          pageNumber:this.pageNumber,
          pageSize:this.pageSize,
        }
      })
    },

    delTags:function(){
      this.souchs = {},
      this.souchs.souType = '';
      this.value = '';
      this.typeValue = '';
      this.accountType = '';
      this.proName = '';
      this.dynamicTags = [];
      this.pageNumber = 1;
      this.getList();
    },

    handleClose(tag) {
      if(tag == "类型"){
        this.souchs.souType ="";
        this.typeValue = '';
      }
      if(tag == "订单"){
        this.souchs.souAccount ="";
        this.accountType = '';
      }
      if(tag == "用户"){
        this.souchs.name="";
        if(this.value == "用户"){
          this.proName = '';
        }
      }
      if(tag == "企业"){
        this.souchs.usercompany="";
        if(this.value == "企业"){
          this.proName = '';
        }
      }
      if(tag == "ID"){
        this.souchs.id ="";
        if(this.value == "ID"){
          this.proName = '';
        }
      }
      if(tag == "操作人"){
        this.souchs.adminusername ="";
        if(this.value == "操作人"){
          this.proName = '';
        }
      }
      if(tag == "价格"){
        this.souchs.price ="";
        if(this.value == "价格"){
          this.proName = '';
        }
      }
      if(tag == "开始日期"){
        this.souchs.fromtime ="";
      }
      if(tag == "结束日期"){
        this.souchs.totime ="";
      }
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    handleSizeChange(val) {
			this.pageSize = val;
			this.getList();
		},
    handleCurrentChange(val) {
      this.pageNumber = val;
      this.getList();
    },
    handleDel:function(index,row){
      this.$confirm('确认撤销吗?', '提示', {
        type: 'warning'
      }).then(() => {
        let param = {
          // token:this.token,
          // checkCode:this.checkCode,
          token: this.userInfo.phone,
          checkCode: this.userInfo.checkCode,
          id:row.id,
          role: this.userInfo.type,
          userId: this.userInfo.id,
        }
        API_Order.delOrder(param)
        .then((res) =>{
          if(res.data.code == API__code.SUCCESS){
            this.$message({
              message: '撤销成功',
              type: 'success'
            });
            this.getList();
          }else{
            this.$message.error(res.data.message);
            if(res.data.code == 403){
              this.$router.push({path: 'loginAdmin'});
            }
          }
        }).catch(err =>{
          this.$message.error('数据丢失，试试重新登陆！');
        })
      }).catch(err =>{
      });
    },
    indexMethod(index) {
      return (index+1)+(this.pageNumber-1)*this.pageSize;
    },
    getRowClass({ row, column, rowIndex, columnIndex }) {
        if (rowIndex == 0) {
            return "background:#F5F7FA";
        } else {
            return "";
        }
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
    //读取cookie
    getCookie: function() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
            var arr2 = arr[i].split('='); //再次切割
            //判断查找相对应的值
            if (arr2[0] == 'dnnyptadmin_token') {
                this.token = arr2[1]; //保存到保存数据的地方
            } else if (arr2[0] == 'dnnyptadmin_checkCode') {
                this.checkCode = arr2[1];
            } else if (arr2[0] == 'dnnyptadmin_id') {
                this.id = arr2[1];
            }
        }
      }
    }
  },
 
  created(){
    this.getCookie();
    if(this.$route.query.type == 1){
      this.dynamicTags = JSON.parse(this.$route.query.dynamicTags);
      this.souchs = JSON.parse(this.$route.query.souchs);
      this.pageNumber= JSON.parse(this.$route.query.pageNumber);
    }
    this.getList();
  },

}

// String.prototype.getAns = function() {
//   var pattern = /(?=((?!\b)\d{3})+$)/g;
//   return this.replace(pattern, ',');
// }
</script>

<style lang="scss">
.dnnCloud-order-box {
  .base-container-bd {
    .content-hd {
      .el-form-item {
        margin-bottom: 0;
      }
    }
  }
}

</style>
<style scoped>
.el-select {
    display: inline-block;
    position: relative;
    width: 115px;
}
.el-tag + .el-tag {
    margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// OrderList.vue?3d968a68